/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {LoopableList} from "../utils/LoopableList";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {NamedLogger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {gsap} from "gsap";
import {TheCage} from "../TheCage";
import {TheCageGameMode} from "../server/TheCageGameMode";

export class TheCageSound {
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";

    public static REELS_OUT: string = "reelsOut";
    public static REELS_IN: string = "reelsIn";

    public static REELS_LANDING: LoopableList<string> = new LoopableList([
        "reelLanding1",
        "reelLanding2",
        "reelLanding3",
        "reelLanding4",
        "reelLanding5",
        "reelLanding6"]).setRandomizeAtWrapAround(true);

    public static SYM_COLLAPSE: LoopableList<string> = new LoopableList([
        "symCollapse1",
        "symCollapse2",
        "symCollapse3",
        "symCollapse4",
        "symCollapse5",
        "symCollapse6"]).setRandomizeAtWrapAround(true);

    public static SYM_LAND_NEAR_WIN: LoopableList<string> = new LoopableList([
        "reelLandAnticipation01",
        "reelLandAnticipation02",
        "reelLandAnticipation03",
        "reelLandAnticipation04"]).setRandomizeAtWrapAround(true);

    public static SCATTER_LANDING_S1 = [
        "s1Land1",
        "s1Land2",
        "s1Land3",
    ];

    public static X_BOMB_EXPLODE_FUSE_LOOP = "xBombExplodeFuseLoop";
    public static X_BOMB_EXPLODE_START = new LoopableList([
        "xBombExplodeStart01",
        "xBombExplodeStart02",
        "xBombExplodeStart03"
    ]).setRandomizeAtWrapAround(true);

    public static X_BOMB_LANDING = new LoopableList([
        "xBombLand01",
        "xBombLand02",
        "xBombLand03",
    ]).setRandomizeAtWrapAround(true);

    public static X_BOMB_EXPLODE: LoopableList<string> = new LoopableList([
        "xBombExplode01",
        "xBombExplode02",
        "xBombExplode03"
    ]).setRandomizeAtWrapAround(true);

    public static X_BOMB_EXPLODE_ABORT: LoopableList<string> = new LoopableList([
        "xBombExplodeAbort01",
        "xBombExplodeAbort02",
        "xBombExplodeAbort03"
    ]).setRandomizeAtWrapAround(true);

    public static MAIN_GAME_MUSIC_1: string = "main1";
    public static MAIN_GAME_MUSIC_2: string = "main2";
    public static FS_MUSIC_LEVEL_1_AND_3: string = "fsLevel1And3";
    public static FS_MUSIC_LEVEL_2_AND_4: string = "fsLevel2And4";
    public static FS_MUSIC_LEVEL_5: string = "fsLevel5";
    static COUNT_UP: string = "countup";
    static COUNT_UP_ENDS_LARGE: string = "countupEndsLarge";
    static COUNT_UP_ENDS_MEDIUM: string = "countupEndsMedium";
    static COUNT_UP_ENDS_SMALL: string = "countupEndsSmall";
    static COUNT_UP_ENDS_TINY: string = "countupEndsTiny";
    static WIN_HIGHLIGHT_TINY: string = "winHighLightTiny";
    static WIN_HIGHLIGHT_SMALL: string = "winHighLightSmall";
    static WIN_HIGHLIGHT_MEDIUM: string = "winHighLightMid";
    static WIN_HIGHLIGHT_LARGE: string = "winHighLightLarge";
    static WIN_SWEEP_TINY: string = "winHighLightTinySweep";
    static WIN_SWEEP_SMALL: string = "winHighLightSmallSweep";
    static WIN_SWEEP_MEDIUM: string = "winHighLightMidSweep";
    static WIN_SWEEP_LARGE: string = "winHighLightLargeSweep";
    static WIN_TINY: string = "";
    static WIN_SMALL: string = "";
    static WIN_MEDIUM: string = "";
    static WIN_LARGE: string = "";
    static WIN_BOTHWAYS_SWEEP: string = "fsBothWaysSweep";
    static WIN_BOTHWAYS_EXPLODE: string = "fsBothWaysExplode";
    static BIG_WIN_LEVEL_1: string = "bigwinLevel1";
    static BIG_WIN_LEVEL_2: string = "bigwinLevel2";
    static BIG_WIN_LEVEL_3: string = "bigwinLevel3";
    static BIG_WIN_LEVEL_4: string = "bigwinLevel4";
    static BIG_WIN_LEVEL_5: string = "bigwinLevel5";
    static BIG_WIN_END: string = "bigwinEnds";
    static CONTINUE_BUTTON: string = "continueButton";
    static FS_WIN: string = "scatterWin";
    static FS_RE_TRIGGER: string = "fsRetrigger";
    static ANTICIPATION_START: string = "scatterAnticipation";
    static ANTICIPATION_END: string = "scatterAnticipationFail";
    public static WILD_MINING: LoopableList<string> = new LoopableList([
        "wildMining",
        "wildMining2",
    ]).setRandomizeAtWrapAround(true);
    static BROKE_BANK_COUNTUP: string = "capWinCountup";
    static BROKE_BANK_LOOP: string = "capWinLoop";
    static BROKE_BANK_END: string = "capWinEnds";
    static FS_INTRO: string = "fsIntro";
    static FS_INTRO_LVL5: string = "fsIntroLevel5";
    static FS_INTRO_START: string = "fsIntroStart";
    static FS_LVL1_TO_4_END: string = "fsLevel1To4Ends";
    static FS_LVL5_END: string = "fsLevel5Ends";
    static FS_END_SWEEP: string = "fsEndsSweep";
    static FS_OUTRO_LOOP: string = "fsOutro";
    static FS_OUTRO_COUNTUP_END: string = "countupEndsFsOutro";
    static FS_FRAME_APPEAR: string = "fsFeatureFrame";
    static FS_FEATURE_APPEAR: string = "fsFeatureFrameSquare1to3";
    static FS_FEATURE_APPEAR_4: string = "fsFeatureFrameSquare4";
    static FS_HP_UP: string = "fsHpUp";
    static FS_ENEMY_HP_UP: string = "fsHpUpFighter";
    static FS_ENEMY_HP_EXPLODE: string = "fsMeterExplode";
    static FS_FIGHTER_NAME_APPEAR: string = "fsIntroFighterName";
    static FS_SPINS_TEXT_APPEAR: string = "fsIntroSpinsText";
    public static FS_PUNCH: LoopableList<string> = new LoopableList([
        "fsPunch1",
        "fsPunch2",
        "fsPunch3"
    ]).setNoDuplicates();
    public static FS_PUNCH_FINAL: string = "fsPunchFinal";
    public static FS_PUNCH_SWEEP: string = "fsPunchSweep";
    public static FS_GLOVE_LAND: string = "fsGloveLanding";
    public static FS_TRANSFORM: string = "fsTransformLowToHigh";
    public static FS_TRANSFORM_2: string = "fsTransformLowToHigh2";
    public static FS_TRANSFORM_3: string = "fsTransformLowToHigh3";
    public static FS_MULTIPLIER: string = "fsMultiplier";
    public static UPGRADE_MOVE: string = "fsUpgradeMove";
    public static BIRD_TO_COLLECTOR: string;
    public static BIRD_TO_PAYER: string;
    private _currentMusic: string;
    private player: NolimitAudioPlayer;
    private logger: NamedLogger;
    private mainLoopCrossfadeTimeline: gsap.core.Timeline;
    private playMainLoop2: boolean;
    private countUpLoop: NolimitHowl | undefined;
    private currentWinSound: string;
    private freespinsOutroLoop: NolimitHowl | undefined;

    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound;
        this.logger = new NamedLogger("DCSound");
        this.mainLoopCrossfadeTimeline = gsap.timeline();
        this.playMainLoop2 = false;
    }


    private static createConfig(name: string, volume?: number, fVolume?: number, repeat?: number, fadeDur?: number) {
        return {
            name: name,
            volume: volume,
            fVolume: fVolume,
            repeat: repeat,
            fadeDurr: fadeDur
        }
    }

    public playLoopingSound(name: string, volume?: number, fadeVolume?: number, repeat?: number, fadeDuration?: number): void {
        this.playAndGetLoopingSound(name, volume, fadeVolume, repeat, fadeDuration);
    }

    public playAndGetLoopingSound(name: string, volume?: number, fadeVolume?: number, repeat?: number, fadeDuration?: number): NolimitHowl | undefined {
        const sound = this.playAndGetSound(name, volume, fadeVolume, repeat, fadeDuration);
        if (sound) {
            sound.setLoop(true);
        }
        return sound;
    }

    public playSound(name: string, volume?: number, fadeVolume?: number, repeat?: number, fadeDuration?: number): void {
        this.playAndGetSound(name, volume, fadeVolume, repeat, fadeDuration);
    }

    public playAndGetSound(name: string, volume?: number, fadeVolume?: number, repeat?: number, fadeDuration?: number): NolimitHowl | undefined {
        this.logger.log("playSound: " + name);
        return this.player.playTrack(TheCageSound.createConfig(name, volume, fadeVolume, repeat, fadeDuration));
    }

    public stopSound(name: string, fadeOutMS: number = 0) {
        if (fadeOutMS > 0) {
            const tl = gsap.timeline();
            tl.add(() => {
                this.player.fadeTrack({name: name, to: 0, duration: fadeOutMS})
            });
            tl.add(() => {
                this.player.stopTrack(name)
            }, fadeOutMS * 0.001);

        } else {
            this.player.stopTrack(name);
        }
    }

    public switchMusic(mode: GameMode | string) {
        let nextMusic = "";

        switch (mode) {
            case "FS_INTRO":
                nextMusic = TheCageSound.FS_INTRO;
                break;
            case "FS_INTRO_LVL5":
                nextMusic = TheCageSound.FS_INTRO_LVL5;
                break;
            case GameMode.FREESPIN:
            case TheCageGameMode.FREESPIN_AVALANCHE:
                // for restore
                switch (TheCage.model.data.fsLevel) {
                    case 4:
                        nextMusic = TheCageSound.FS_MUSIC_LEVEL_5;
                        break;
                    case 1:
                    case 3:
                        nextMusic = TheCageSound.FS_MUSIC_LEVEL_2_AND_4;
                        break;
                    case 0:
                    case 2:
                    default:
                        nextMusic = TheCageSound.FS_MUSIC_LEVEL_1_AND_3;
                        break;
                }
                break;
            case "FS_LEVEL_1":
            case "FS_LEVEL_3":
                nextMusic = TheCageSound.FS_MUSIC_LEVEL_1_AND_3;
                break;
            case "FS_LEVEL_2":
            case "FS_LEVEL_4":
                nextMusic = TheCageSound.FS_MUSIC_LEVEL_2_AND_4;
                break;
            case "FS_LEVEL_5":
                nextMusic = TheCageSound.FS_MUSIC_LEVEL_5;
                break;
            default:
                nextMusic = TheCageSound.MAIN_GAME_MUSIC_1;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            if (this._currentMusic == TheCageSound.MAIN_GAME_MUSIC_1 || this._currentMusic == TheCageSound.MAIN_GAME_MUSIC_2) {
                this.player.stopTrack(TheCageSound.MAIN_GAME_MUSIC_1);
                this.player.stopTrack(TheCageSound.MAIN_GAME_MUSIC_2);
            } else {
                this.player.stopTrack(this._currentMusic);
            }
        }

        if (nextMusic == TheCageSound.MAIN_GAME_MUSIC_1) {
            this.player.playTrack(TheCageSound.createConfig(TheCageSound.MAIN_GAME_MUSIC_1, this.playMainLoop2 ? 0 : 1, undefined));
            this.player.playTrack(TheCageSound.createConfig(TheCageSound.MAIN_GAME_MUSIC_2, this.playMainLoop2 ? 1 : 0, undefined));
        } else {
            this.player.playTrack(TheCageSound.createConfig(nextMusic, 1, undefined));
        }
        this._currentMusic = nextMusic;
    }

    public crossfadeToMain2() {
        if (this._currentMusic && this._currentMusic == TheCageSound.MAIN_GAME_MUSIC_1) {
            this.player.fadeTrack({name: this._currentMusic, to: 0, duration: 500});
            this._currentMusic = TheCageSound.MAIN_GAME_MUSIC_2;
            this.player.fadeTrack({name: this._currentMusic, to: 1, duration: 500});
        }
        this.playMainLoop2 = true;

        this.mainLoopCrossfadeTimeline.clear();
        this.mainLoopCrossfadeTimeline.add(() => {
            if (this._currentMusic && this._currentMusic == TheCageSound.MAIN_GAME_MUSIC_2) {
                this.player.fadeTrack({name: this._currentMusic, to: 0, duration: 5000});
                this._currentMusic = TheCageSound.MAIN_GAME_MUSIC_1;
                this.player.fadeTrack({name: this._currentMusic, to: 1, duration: 5000});
            }
            this.playMainLoop2 = false;
        }, '<30');
    }

    public setMainToMain1() {
        this.playMainLoop2 = false;
    }

    public playWinSound(name: string) {
        this.stopWinSound();
        this.playSound(name);
        this.currentWinSound = name;
    }

    public stopWinSound() {
        this.stopSound(this.currentWinSound);
    }

    public startCountUp() {
        this.countUpLoop = this.playAndGetSound(TheCageSound.COUNT_UP);
        if (this.countUpLoop) {
            this.countUpLoop.setLoop(true);
        }
    }

    public endCountUp(endSound: string) {
        if (this.countUpLoop) {
            if (endSound != "") {
                this.playSound(endSound);
            }
            this.stopSound(TheCageSound.COUNT_UP, 50);
            delete this.countUpLoop;
        }
    }

    public startFreespinsOutro() {
        this.freespinsOutroLoop = this.playAndGetSound(TheCageSound.FS_OUTRO_LOOP);
        if (this.freespinsOutroLoop) {
            this.freespinsOutroLoop.setLoop(true);
        }
    }

    public endFreespinsOutro() {
        if (this.freespinsOutroLoop) {
            this.stopSound(TheCageSound.FS_OUTRO_LOOP, 50);
            delete this.freespinsOutroLoop;
        }
    }

    public fadeOutMusic(duration: number = 300, targetVolume: number = 0) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name: this._currentMusic,
                to: targetVolume,
                duration: duration
            });
        }
    }

    public fadeInMusic(duration: number = 300) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name: this._currentMusic,
                to: 1,
                duration: duration
            });
        }
    }

    public playXBombExplode(count: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (count == 0) {
            tl.add(() => {
                this.playSound(TheCageSound.X_BOMB_EXPLODE.next())
            });
        } else {
            tl.add(() => {
                this.playSound(TheCageSound.X_BOMB_EXPLODE_ABORT.next())
            });
        }

        return tl;

    }
}